import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, createSelector } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { Filtro, FiltroComponent } from "./filtro";
import { ClienteMultiselectorList } from "./listmem";

interface Props {
    value: number[];
    onChange: (x: number[]) => void;
    idSucursalCobranza: number;
    label: string;
    error?: kea.FieldError;
}
export class MultiClienteList extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        this.state = { filtro: {} }
    }
    modalManager = kea.createModalManager();

    idSucursal = (x: Props) => x.idSucursalCobranza;
    items = createSelectorRx(this.idSucursal, idSuc => observeResource(resources.Cobranza2.ObtenerClientesPendientes, idSuc));


    render() {
        return (
            <div>
                <kea.Panel title={this.props.label} error={this.props.error} >
                    {
                        this.props.idSucursalCobranza ?
                            <ClienteMultiselectorList
                                value={this.props.value}
                                onChange={this.props.onChange}
                                items={this.items(this.props)}
                            /> :
                            <div className="alert alert-warning">
                                Seleccione una sucursal para mostrar los clientes
                            </div>
                    }
                </kea.Panel>
                {this.modalManager.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/modales/nuevoviaje/multicliente/list.tsx